import { Component, OnInit } from '@angular/core';
import { ManagedLinkKey } from 'src/common/managedLinkKey';

@Component({
	selector: 'app-faltantes',
	templateUrl: './faltantes.component.html',
	styleUrls: ['./faltantes.component.scss']
})
export class FaltantesComponent {

	faltantesFormKey: ManagedLinkKey = ManagedLinkKey.FALTANTES_FORM;

	constructor() {
	}

}
